import { useEffect, useState } from 'react'

type UseCountdownArgs = { duration: number | null; onFinishAction?: () => void; counterOn?: boolean }

export const useCountdown = ({ duration, onFinishAction, counterOn = true }: UseCountdownArgs) => {
  const [countdown, setCountdown] = useState(duration)

  useEffect(() => {
    if (!counterOn) return

    const updateCounter = () => {
      setCountdown(timeLeft => Math.max(((timeLeft ?? duration) as number) - 1, 0))
    }

    updateCounter()

    const interval = setInterval(updateCounter, 1000)

    return () => clearInterval(interval)
  }, [counterOn])

  useEffect(() => {
    if (countdown === 0) {
      onFinishAction && onFinishAction()
    }
  })

  return countdown
}
